import Cookies from 'universal-cookie';

import { isBrowser } from '~/utilities/helpers';

export const CONSENT_COOKIE_NAME = 'ab_consent_v1';

export const CONSENT_VERSION = 1;

export const CONSENT_DECISION = {
    UNSET: 'unset',
    SET: 'set'
};

export const CONSENT_CATEGORIES = {
    NECESSARY: 'necessary',
    FUNCTIONAL: 'functional',
    MARKETING: 'marketing'
};

export const defaultConsent = {
    v: CONSENT_VERSION,
    decision: CONSENT_DECISION.UNSET,
    functional: false,
    marketing: false
};

const CONSENT_MAX_AGE = 60 * 60 * 24 * 180; // ~180 days, in seconds

// Cookies written by each gated category, removed when the category is declined.
const MARKETING_COOKIES = ['utms'];
const FUNCTIONAL_COOKIES = ['selectedLocation', 'userLocation'];

const cookieOptions = () => ({
    path: '/',
    sameSite: 'lax',
    secure: process.env.NODE_ENV === 'production',
    maxAge: CONSENT_MAX_AGE
});

const normalize = (value) => ({
    v: CONSENT_VERSION,
    decision:
        value && value.decision === CONSENT_DECISION.SET
            ? CONSENT_DECISION.SET
            : CONSENT_DECISION.UNSET,
    functional: Boolean(value && value.functional),
    marketing: Boolean(value && value.marketing)
});

export const getConsent = () => {
    if (!isBrowser()) {
        return { ...defaultConsent };
    }

    try {
        const stored = new Cookies().get(CONSENT_COOKIE_NAME);

        if (!stored) {
            return { ...defaultConsent };
        }

        return normalize(stored);
    } catch (error) {
        return { ...defaultConsent };
    }
};

export const setConsent = ({ functional, marketing } = {}) => {
    const consent = normalize({
        decision: CONSENT_DECISION.SET,
        functional,
        marketing
    });

    if (isBrowser()) {
        try {
            new Cookies().set(CONSENT_COOKIE_NAME, consent, cookieOptions());
        } catch (error) {
            // Ignore write failures.
        }
    }

    return consent;
};

export const clearCategoryCookies = ({ functional, marketing } = {}) => {
    if (!isBrowser()) {
        return;
    }

    try {
        const cookies = new Cookies();

        if (!marketing) {
            MARKETING_COOKIES.forEach((name) =>
                cookies.remove(name, { path: '/' })
            );
        }

        if (!functional) {
            FUNCTIONAL_COOKIES.forEach((name) =>
                cookies.remove(name, { path: '/' })
            );
        }
    } catch (error) {
        // Ignore removal failures.
    }
};

export const clearConsent = () => {
    if (isBrowser()) {
        try {
            new Cookies().remove(CONSENT_COOKIE_NAME, { path: '/' });
        } catch (error) {
            // Ignore removal failures.
        }
    }
};
